<template>
  <nav-bar title="钢瓶流通管理" />
  <Content :bottom="0">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <ul v-if="list.length" class="list">
      <cylinder-management-item v-for="item in list" :key="item.departId" :item="item" @click="handleItemClick(item)" />
    </ul>
    <Empty v-else description="没有查询到钢瓶流通管理信息" />
  </Content>
</template>

<script>
import { ref, computed } from 'vue'
import { getCompanyOrderInfoList } from '@/api/agentMess'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
  name: 'CylinderCrculation', // 钢瓶流通管理
  setup () {
    // 获取钢瓶流通管理信息
    const store = useStore()
    const list = ref([])
    const companyId = computed(() => store.state.roleInfo.companyId)
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(getCompanyOrderInfoList, (data) => {
      list.value = data
    }, companyId.value)
    getDataLoading()

    // 跳转
    const router = useRouter()
    const handleItemClick = ({ groupId }) => {
      router.push(`/cylinderCrculationDetail/${groupId}`)
    }

    return {
      getDataLoading,
      isLoading,
      showLoading,
      list,
      handleItemClick
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  margin: 16px 16px 0 16px;
  font-size: 14px;
  color: #666;
}
</style>
